module.exports = __webpack_public_path__ + "img/bell_curve_example.4ba29975.png";